import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isHotelDealPerformanceEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isHotelDealPerformanceEnabled>[0];
  isLoading: boolean;
}>;

export default function HotelDealPerformanceRouteGate({ user, isLoading, children }: Props) {
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isHotelDealPerformanceEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
